export class UserModel {
    id: string | undefined;
    username: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    password: string | undefined;
    isActive: boolean | undefined;
}